import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploaderService {

  onUploadStarted = new Subject();
  onUploadFinished = new Subject();
  onUploadError = new Subject();
  attachments = new BehaviorSubject([]);
  removedAttachments = new BehaviorSubject([]);
  onSubmitClicked = new Subject();
  previewFiles = new BehaviorSubject([]);

  notesAttachments = new BehaviorSubject([]);
  removedNotesAttachments = new BehaviorSubject([]);
  notesPreviewFiles = new BehaviorSubject([]);

  constructor() { }

  getAllowedMimeType(allowedFileType: string[]): string[] {
    const allowedMimeType: string[] = [];
    allowedFileType?.forEach((fileType: string) => {
      if (fileType === 'image') {
        allowedMimeType.push(...[
          'image/jpg',
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/dng',
          'image/DNG',
          'image/svg+xml']);
      } else if (fileType === 'video') {
        allowedMimeType.push(...[
          'video/x-msvideo',
          'video/mp4',
          'video/mpeg',
          'video/ogg',
          'video/webm',
          'video/3gpp',
          'video/quicktime',
        ]);
      } else if (fileType === 'audio') {
        allowedMimeType.push(...[
          'audio/aac',
          'audio/wav',
          'audio/mpeg',
          'audio/ogg',
          'audio/webm',
          'audio/3gpp'
        ]);
      } else if (fileType === 'pdf') {
        allowedMimeType.push('application/pdf');
      } else if (fileType === 'doc') {
        allowedMimeType.push(...[
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
          'application/vnd.ms-word.document.macroEnabled.12',
          'application/vnd.ms-word.template.macroEnabled.12']);
      } else if (fileType === 'xls') {
        allowedMimeType.push(...[
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
          'application/vnd.ms-excel.sheet.macroEnabled.12',
          'application/vnd.ms-excel.template.macroEnabled.12',
          'application/vnd.ms-excel.addin.macroEnabled.12',
          'application/vnd.ms-excel.sheet.binary.macroEnabled.12']);
      } else if (fileType === 'ppt') {
        allowedMimeType.push(...[
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.openxmlformats-officedocument.presentationml.template',
          'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
          'application/vnd.ms-powerpoint.addin.macroEnabled.12',
          'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
          'application/vnd.ms-powerpoint.slideshow.macroEnabled.12']);
      } else if (fileType === 'compress') {
        allowedMimeType.push(...[
          'application/x-gtar',
          'application/x-gcompress',
          'application/compress',
          'application/zip',
          'application/x-tar',
          'application/x-rar-compressed',
          'application/octet-stream',
          'application/x-zip-compressed',
          'application/zip-compressed',
          'application/x-7z-compressed',
          'application/gzip',
          'application/x-bzip2']);
      }else if(fileType === 'application'){
        allowedMimeType.push(...[
         'application/vnd.ms-outlook',
         'message/rfc822',
         ''
        ]);
      }
    });
    return allowedMimeType;
  }
}
